import React from 'react';

const SurveyHeader = ({ survey, theme }) => {
    if (!survey?.title && !survey?.description) return null;

    const headingTag = survey.headingType || 'h2';
    const titleAlign = survey.headerPosition || 'left';
    const descriptionAlign = survey.descriptionPosition || 'left';

    return (
        <div className="ecx-survey-preview__header">
            {survey.title
                ? React.createElement(
                      headingTag,
                      {
                          className: `ecx-survey-preview__title text-${titleAlign}`,
                          style: { color: theme?.colors?.primary || '#181c32' },
                      },
                      survey.title
                  )
                : null}

            {survey.description ? (
                <p
                    className={`ecx-survey-preview__description text-${descriptionAlign} mb-0`}
                    style={{ color: survey.descriptionColor || '#7e8299' }}
                >
                    {survey.description}
                </p>
            ) : null}
        </div>
    );
};

export default SurveyHeader;
